import React, {Component} from 'react';
import {  loadJudgeConflicts, reviseJudgeConflict,  AuthenticatedUser, putToast, stopTimer } from "../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from './tournamentPageTemplate'

class TournamentCompetitorConflicts extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onJudgeConflictUpdate = this.onJudgeConflictUpdate.bind(this);
        this.getTdProps = this.getTdProps.bind(this);

        this.state = {
            loading: true,
            open: false,
            user: user,
            tData: {},
            pid: params.pid,
            conflicts: []
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            loadJudgeConflicts(this.state.pid, this.state.user._id).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                    this.setState({ loading: false});
                } else {
                    this.setState({tData: d2.tournamentPage, conflicts: d2.judgeConflicts, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row) {
            if (column.id !== "conflicted" && column.id !== "designated") {
                return {
                    onClick: () => { 
                        //const roomId = rowInfo.original.roomId;
                        //const judgeId = rowInfo.original.judge.userId;
                        //this.props.history.push(`/tournament/ballot/room/judge/${this.state.tData._id}/${roomId}/${judgeId}`)
                    },
                    onMouseOver: (e) => {
                        this.setState({
                            selected: rowInfo.index
                        })
                    },
                    style: {
                        background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                        //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                }
            } else { 
                return {
                    style: {
                        background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                        //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                }
            }
        } else {
            return {}
        }
    }

    onJudgeConflictUpdate(evt) {
        const {tData, conflicts, user} = this.state;

        const id = evt.target.id.substring(3);
        const val = evt.target.checked;
        const conflict = conflicts.find(x=>x.competitorId === id);
        if (conflict) {
            if (evt.target.id.startsWith("isc")) {
                conflict.isConflicted = val;
                if (!val) { 
                    conflict.isDesignated = val; // if !conflicted, then can't be designated
                    const cb = document.getElementById(`isd${id}`);
                    cb.checked = val;
                }
            }
            if (evt.target.id.startsWith("isd")) {
                conflict.isDesignated = val;
                if (val) { 
                    conflict.isConflicted = val; // if designated, also conflicted
                    const cb = document.getElementById(`isc${id}`);
                    cb.checked = val;
                }
            }
        }

        reviseJudgeConflict(tData._id, user._id, id, {isConflicted: conflict.isConflicted , isDesignated: conflict.isDesignated}).then(d2 => {
            if (!d2 || d2.error) {
                console.log(d2 ? d2.error : "Error - no data");
                putToast.error(d2 ? d2.error : "Error - no data");
            } else {
                putToast.success(d2.message);
                this.setState({ tData });                    
            }
        });     

        this.setState({conflicts})
    }
    
    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user, conflicts } = this.state;


            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Judge Conflict List - ${user.displayname}`} title3=""
                bcTitle="Judge Conflict List" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                ]}
                >             
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                        <h5><strong>For Conflicts:</strong> Please check the boxes of all competitors you have coached, are related to, or basically "do life" with.</h5>
                        <h5><strong>For Designated:</strong> Please check the boxes of all competitors requesting that you be their designated judge.  This will automatically make them a conflict as well.</h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">                        
                            <ReactTable
                                filterable
                                data={conflicts}
                                defaultFilterMethod={ (filter, row, column) => {
                                    const id = filter.pivotId || filter.id
                                    return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                }}
                                columns={[{
                                    Header: 'Conflict',
                                    id: 'conflicted',
                                    accessor: 'isConflicted',
                                    style: { textAlign: 'center'},
                                    headerStyle: { textAlign: 'center', fontSize: "18px"}, 
                                    maxWidth: 100,                                   
                                    Cell: (row) => {
                                     return (
                                        <input
                                            type='checkbox'
                                            id={'isc'+row.original.competitorId}
                                            checked={row.original.isConflicted}
                                            onChange={this.onJudgeConflictUpdate}
                                            style={{zoom: "1.2", width: "20px", height: "20px"}}
                                        />                                          
                                     )}
                                },{
                                    Header: 'Designated',
                                    id: 'designated',
                                    accessor: 'isDesignated',
                                    style: { textAlign: 'center'},
                                    headerStyle: { textAlign: 'center', fontSize: "18px"}, 
                                    maxWidth: 120,                                   
                                    Cell: (row) => {
                                     return (
                                        <input
                                            type='checkbox'
                                            id={'isd'+row.original.competitorId}
                                            checked={row.original.isDesignated}
                                            onChange={this.onJudgeConflictUpdate}
                                            style={{zoom: "1.2", width: "20px", height: "20px"}}
                                        />                                          
                                     )}
                                },{
                                    Header: 'First',
                                    accessor: 'firstname',
                                    maxWidth: 200,      
                                    style: { fontSize: '16px'},     
                                    headerStyle: { textAlign: 'left', fontSize: "18px"},                         
                                },{
                                    Header: 'Last',
                                    accessor: 'lastname',
                                    maxWidth: 200,      
                                    style: { fontSize: '16px'},     
                                    headerStyle: { textAlign: 'left', fontSize: "18px"},                         
                                },{
                                    Header: 'Club',
                                    accessor: 'club',
                                    headerStyle: { textAlign: 'left', fontSize: "18px"}, 
                                }]}                                        
                                pageSize={(conflicts.length > 20) ? 20 : conflicts.length}
                                showPagination={(conflicts.length > 20)}                    
                                defaultPageSize={20}   
                                getTdProps={this.getTdProps}                                                                                                                                                                        
                            />
                        </div>
                    </div>  
                </div>              
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentCompetitorConflicts;